import React from 'react'

export const DeveloperCatIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask id="mask0_5892_56719" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_5892_56719)">
            <path className="prompt-icon" d="M5.33167 11.7698L1.5625 8.00061L5.33167 4.23145L6.0445 4.94428L2.97783 8.01095L6.03417 11.0673L5.33167 11.7698ZM10.665 11.7698L9.95217 11.0569L13.0188 7.99028L9.9625 4.93395L10.665 4.23145L14.4342 8.00061L10.665 11.7698Z" fill="white"/>
        </g>
    </svg>
  )
}
